import React from "react";

const PendingIcon = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.46984 12H12.5302C13.6612 12 14.3662 10.8217 13.8007 9.88329L8.27054 0.703807C7.70504 -0.234602 6.29496 -0.234602 5.72946 0.703807L0.1993 9.88329C-0.366201 10.8217 0.338839 12 1.46984 12ZM7 7.061C6.59607 7.061 6.26558 6.7435 6.26558 6.35543V4.94429C6.26558 4.55623 6.59607 4.23872 7 4.23872C7.40393 4.23872 7.73442 4.55623 7.73442 4.94429V6.35543C7.73442 6.7435 7.40393 7.061 7 7.061ZM7.73442 9.88329H6.26558V8.47215H7.73442V9.88329Z"
        fill="#0F7AE2"
      />
    </svg>
  );
};

export default PendingIcon;
